const logo = () => {
  return {
    to: "/",
    image: {
      header: "2yuI2rEeOhSQ8e7ELmvU8U.svg",
      footer: "1t4B9bQrPdx6C8Ym1mU1b-.svg"
    }
  };
};

export default {
  path: "/",
  name: "helpcenter.life",
  meta: {
    logo: logo(),
    description: {
      banner: "CommonBanner"
    }
  },
  component: () => import("@/views/Home.vue")
};
